const _window = window.self === window.parent ? window : window.parent;

let absolutePathAnchor;

try
{  
    absolutePathAnchor = `${_window.location.pathname}${_window.location.search}#`;
}
catch ( e )
{
    absolutePathAnchor = '';
}

class Config
{
    constructor ()
    {
        this.absolutePathAnchor = absolutePathAnchor;
        this.domain = "linkello.pro";
        this.soundUrl = "https://office.linkello.com/app/sounds/entering.mp3";
        this.logoUrl = "https://office.linkello.com/app/images/linkello/logo_header.png";
        this.blurFilter = "https://office.linkello.com/app/themes/linkello/img/jpg/blur.jpg";
        this.backgroundUrl = "";
        this.backgroundRepeat = false;
        this.signature = "";
        this.exitUrl = "";
        this.videoBgImgUrls = [];
        this.videoWatermarkUrl = undefined;
        this.ratingOn = true;
        this.testsDomain = "webrtc-tests.bistri.com";
        this.linkelloUrl = "https://call.linkello.com";
        this.chat = true;
        this.app = "";
        this.name = "";
        this.lang = "";
    }

    set ( data )
    {
        for ( const prop in data )
        {
            if ( prop in this && typeof data[ prop ] !== "undefined" )
            {
                this[ prop ] = data[ prop ];
            }
        }
    }
}

export default new Config ();